module.exports = __webpack_public_path__ + "media/images/flf-texture_smooth-4eaeff192beece5798c686a38419319c.jpg";